import api from './api';

export const plannerService = {
  // Pobierz wszystkie zadania serwisowe
  getTasks: async (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const response = await api.get(`/planner/tasks?${params.toString()}`);
    return response.data;
  },

  // Pobierz zadanie po ID
  getTask: async (id) => {
    const response = await api.get(`/planner/tasks/${id}`);
    return response.data;
  },

  // Dodaj nowe zadanie serwisowe
  addTask: async (taskData) => {
    const response = await api.post('/planner/tasks', taskData);
    return response.data;
  },

  // Aktualizuj zadanie
  updateTask: async (id, taskData) => {
    const response = await api.put(`/planner/tasks/${id}`, taskData);
    return response.data;
  },

  // Usuń zadanie
  deleteTask: async (id) => {
    const response = await api.delete(`/planner/tasks/${id}`);
    return response.data;
  },

  // Oznacz realizację zadania z Kanban
  completeTask: async (taskId, kanbanCardId) => {
    const response = await api.put(`/planner/tasks/${taskId}/complete`, { kanbanCardId });
    return response.data;
  },

  // Oznacz element checklista jako wykonany
  completeChecklistItem: async (taskId, kanbanCardId, checklistId, itemId) => {
    const response = await api.put(`/planner/tasks/${taskId}/complete-checklist-item`, { 
      kanbanCardId, 
      checklistId, 
      itemId 
    });
    return response.data;
  },

  // ==================== EKIPY SERWISOWE ====================
  
  // Pobierz wszystkie ekipy serwisowe
  getTeams: async () => {
    const response = await api.get('/planner/teams');
    return response.data;
  },

  // Dodaj nową ekipę serwisową
  addTeam: async (teamData) => {
    const response = await api.post('/planner/teams', teamData);
    return response.data;
  },

  // Aktualizuj ekipę serwisową
  updateTeam: async (id, teamData) => {
    const response = await api.put(`/planner/teams/${id}`, teamData);
    return response.data;
  },

  // Usuń ekipę serwisową
  deleteTeam: async (id) => {
    const response = await api.delete(`/planner/teams/${id}`);
    return response.data;
  },

  // ==================== FARMY ====================

  // Pobierz wszystkie farmy
  getFarms: async () => {
    const response = await api.get('/planner/farms', {
      params: {
        _t: Date.now() // Dodaj timestamp aby uniknąć cache
      },
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    console.log('[plannerService.getFarms] Pełna odpowiedź z API:', response);
    console.log('[plannerService.getFarms] response.data:', response.data);
    console.log('[plannerService.getFarms] response.data.farms:', response.data?.farms);
    console.log('[plannerService.getFarms] Typ response.data.farms:', typeof response.data?.farms);
    console.log('[plannerService.getFarms] Czy farms jest tablicą:', Array.isArray(response.data?.farms));
    console.log('[plannerService.getFarms] Długość farms:', response.data?.farms?.length);
    
    // Zwróć dane, upewniając się że farms jest tablicą
    const result = {
      ...response.data,
      farms: Array.isArray(response.data?.farms) ? response.data.farms : []
    };
    console.log('[plannerService.getFarms] Zwracany wynik:', result);
    return result;
  },

  // Dodaj nową farmę
  addFarm: async (farmData) => {
    try {
      console.log('Dodawanie farmy:', farmData);
      const response = await api.post('/planner/farms', farmData);
      console.log('Odpowiedź z serwera:', response.data);
      return response.data;
    } catch (error) {
      console.error('Błąd podczas dodawania farmy:', error);
      console.error('Status:', error.response?.status);
      console.error('Data:', error.response?.data);
      throw error;
    }
  },

  // Aktualizuj farmę
  updateFarm: async (id, farmData) => {
    const response = await api.put(`/planner/farms/${id}`, farmData);
    return response.data;
  },

  // Usuń farmę
  deleteFarm: async (id) => {
    const response = await api.delete(`/planner/farms/${id}`);
    return response.data;
  }
};

